import { useEffect, useSyncExternalStore, type ReactNode } from "react";
import { initI18n, isReady, subscribe } from "./store.js";

/**
 * Kicks off the initial catalog fetch and holds rendering until it lands, so
 * no frame ever paints raw message keys. Not a context provider — the store
 * is module-level (see store.ts) — this is purely the boot gate.
 */
export function LanguageProvider({ children }: { children: ReactNode }) {
  const ready = useSyncExternalStore(subscribe, isReady);

  useEffect(() => {
    void initI18n();
  }, []);

  if (!ready) return null;
  return <>{children}</>;
}
